<ng-template [ngIf]="type === 'organization'">
  <sn-organization-form
    [isLoading]="isLoading"
    [currentUserId]="userId"
    [users]="users"
    (send)="onDialogSent($event)"
  >
  </sn-organization-form>
</ng-template>

<ng-template [ngIf]="type === 'direct'">
  <sn-direct-form
    [title]="'common.directMessages' | t"
    [exceptionList]="[userId]"
    [isExternalAllowed]="false"
    [isLoading]="isLoading"
    (send)="onDialogSent($event)"
  >
  </sn-direct-form>
</ng-template>
